
import DetailComponentBase from "@/app/dynamic-components/details/details-components/detail-component.base";
import { DynamicDetailEntry } from "@/app/dynamic-components/details/dynamic-detail.model";
import { DetailContext } from "@/app/contexts/detail.context";
import { Component } from "vue-property-decorator";

export type ListMetaData = {
  selector: string;
  property: string;
  translated: string;
  fromIndexedList: string //point to a list in the definitions, the value will be used to resolve the object of that list (index based)
  fromIndexedTree: string //point to a tree in the definitions, the value will be used to resolve the object of that list (index based)
  fromIndexedTreeChildren: string //tree children element to navigate
  fromIndexedTreeChildId: string //tree children id element to navigate, only for array objects
};

@Component({})
export default class DetailComponentList extends DetailComponentBase<ListMetaData> {
  value: any = null;

  postEntityChanged(newValue: DynamicDetailEntry) {
    this.resolveValues();
  }

  protected postDetailContextChanged(newValue: DetailContext) {
    this.resolveValues();
  }

  private resolveValues(){
    if (this.entry && this.detailContext) {
      this.value = this.detailContext.resolveFieldValue(this.entry.metadata.selector);
      if((this.entry.metadata.fromIndexedList || this.entry.metadata.fromIndexedTree) && this.value && Array.isArray(this.value)) {
        const indexList = JSON.parse(JSON.stringify(this.detailContext.resolveFieldValue(this.entry.metadata.fromIndexedList|| this.entry.metadata.fromIndexedTree)));
        if(this.entry.metadata.fromIndexedTree){
          const clone = JSON.parse(JSON.stringify(indexList));
          if(Array.isArray(indexList)){
            clone.forEach(c => this.appendChilrenToIndexList(indexList,c, this.metadata.fromIndexedTreeChildren))
          }else{
            Object.entries(clone).forEach(entry => this.appendChilrenToIndexList(indexList,entry[1], this.metadata.fromIndexedTreeChildren));
          }
        }
        if(indexList){
          this.value = this.value.map(value1 => indexList[value1] || value1);
        }
      }
    }
  }

  get displayvalue(): string {
    if (!this.value || !this.entry || !this.metadata) return "-";
    let val: string[];
    if (!Array.isArray(this.value)) {
      val = [this.value];
    } else {
      val = this.value;
    }
    if (this.metadata.property) {
      val = val.map((value1) => value1[this.metadata.property]);
    }
    if (this.metadata.translated) {
      val = val.map((v) => this.$tc(v));
    }
    return val.join(", ");
  }

  private appendChilrenToIndexList(collector: any, parent: any, childerenElement: string) {
    if(!parent) return;
    if(!parent[childerenElement]) return;

      if(Array.isArray(parent[childerenElement])){
        if(Array.isArray(parent)){
          parent[childerenElement].forEach(child => {
            this.appendChilrenToIndexList(collector, child, childerenElement);
            collector.push(child);
          });
        }else{
          parent[childerenElement].forEach(child => {
            this.appendChilrenToIndexList(collector, child, childerenElement);
            const childId = child[this.metadata.fromIndexedTreeChildId || 'id'] || Math.abs(Math.random() * 10000)
            collector[childId] = child;
          });
        }
      }else{
        if(Array.isArray(parent)){
          Object.entries(parent[childerenElement]).forEach((entry) => {
            const child = entry[1];
            const childId = entry[0];
            this.appendChilrenToIndexList(collector, child, childerenElement);
            collector.push(child);
          })
        }else{
          Object.entries(parent[childerenElement]).forEach((entry) => {
            const child = entry[1];
            const childId = entry[0];
            this.appendChilrenToIndexList(collector, child, childerenElement);
            collector[childId] = child;
          })
        }
      }
  }
}
